var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01743 11.8926L8.01743 5.353",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0351 7.44566L7.99996 5.353L5.96484 7.44566",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7227 10.1221C15.7227 11.2274 15.303 12.2231 14.6297 12.9403C13.9564 13.6575 13.0218 14.1047 11.9841 14.1047H4.01583C1.94852 14.1047 0.277191 12.3243 0.277191 10.1221C0.277191 9.01676 0.697016 8.02112 1.37026 7.30388C2.04356 6.57825 2.97821 6.13108 4.01583 6.13108C4.01583 3.79381 5.79801 1.89532 7.99996 1.89532C10.202 1.89532 11.9841 3.79381 11.9841 6.13108C14.0515 6.13108 15.7227 7.91987 15.7227 10.1221Z",
    stroke: "white",
    strokeWidth: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12.8,
    fill: "white",
    transform: "translate(-3.05176e-05 1.60001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.b7b84c0716e9cd5d224440f42f55db7d.svg";
export { ForwardRef as ReactComponent };